import * as styles from './UserReviewCard.styles.js';
import { dayjs } from '@contra/date';
import { RecommendationStarFullIcon } from '@contra/icons/icons';

type Props = {
  readonly authorRoleOnProject: string;
  readonly createdAt: string;
  readonly reviewText?: null | string;
  readonly showDate?: boolean;
};

export const UserReviewText = ({
  authorRoleOnProject,
  createdAt,
  reviewText,
  showDate = false,
}: Props) => {
  const dateFormatter = dayjs(createdAt);

  return (
    <div>
      <styles.RecommendationText>
        <RecommendationStarFullIcon />
        <styles.Recommended>Recommended</styles.Recommended>
      </styles.RecommendationText>
      {reviewText ? (
        <styles.UserReviewContent>{reviewText}</styles.UserReviewContent>
      ) : null}

      {showDate ? (
        <>
          <br />
          <styles.WorkDate>
            {`${authorRoleOnProject} • ${dateFormatter.format('MMM D, YYYY')}`}
          </styles.WorkDate>
        </>
      ) : null}
    </div>
  );
};
